import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps, DialogRoot, DialogTrigger } from '@gitbook/spine-react';

import {
    CreateSiteVariantDialog,
    type CreateSiteVariantDialogProps,
} from './CreateSiteVariantDialog';

export interface CreateSiteVariantButtonProps
    extends CreateSiteVariantDialogProps,
        Pick<ButtonProps, 'className' | 'label' | 'size' | 'kind'> {}

export function CreateSiteVariantButton(props: CreateSiteVariantButtonProps) {
    const { className, label, size, kind = 'secondary', ...dialogProps } = props;
    return (
        <DialogRoot>
            <DialogTrigger>
                <Button
                    kind={kind}
                    leadingIcon={Icon.Plus}
                    label={label}
                    className={className}
                    size={size}
                />
            </DialogTrigger>
            <CreateSiteVariantDialog {...dialogProps} />
        </DialogRoot>
    );
}
